module.exports = __webpack_public_path__ + "static/media/logo.eb413b17.svg";